export const HMON_BACKEND = 'https://cloud.rradar.com.br/erp';
